module.exports = __webpack_public_path__ + "img/hakuna_xmas_bg03.83e95a12.jpg";